import React from 'react';

const CalIcon = () => (
    <div className = 'cal--icon'>
        <div></div>
        <div></div>
    </div>
)

export default CalIcon;


// WEBPACK FOOTER //
// ./src/components/common/icons/calendar.js